import { render } from "./TicketsInProgressChart.vue?vue&type=template&id=6d1dbff1&ts=true"
import script from "./TicketsInProgressChart.vue?vue&type=script&lang=ts"
export * from "./TicketsInProgressChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__